<template>
  <div style="height: 100vh">
    <v-content>
      <div class="content-layout -none-menu">
        <router-view></router-view>
      </div>
    </v-content>
  </div>
</template>
<script >
import DisplayUIKey from "@/components/display-ui-key";
import displayUIStore from "@/stores/displayui";


export default{
  name: 'NoneMenuLayout',
  components: {},
}
;
</script>
